import Config from '@/utils/config.ts'
import RequestHttp from '@/utils/request.ts'
namespace Login {
  // 用户登录请求表单
  export interface reqForm {
    account: string
    password: string
    tenant: string
    username: string
  }
  // 用户登录响应表单
  export interface resData {
    errcode: string
    tenant_id: number
    token: string
    user_id: number
  }
}
// 用户登录
export const login = (params: Login.reqForm) => {
  return RequestHttp.post<Login.resData>(`${Config.apiPath}/login`, params)
}
// 一键登录
export const ca9Login = (params: Login.reqForm) => {
  return RequestHttp.post<Login.resData>(`${Config.apiPath}/ca9`, params)
}
export const sendMobileCode = (params: Login.reqForm) => {
  return RequestHttp.post<Login.resData>(`${Config.apiPath}/sendMobileCode`, params)
}
export const forgot = (params: Login.reqForm) => {
  return RequestHttp.post<Login.resData>(`${Config.apiPath}/forgot`, params)
}

namespace UserInfo {
  // 用户信息请求表单
  export interface reqForm {}
  // 用户信息响应表单
  export interface resData {}
}
// 用户信息
export const userInfo = (params: UserInfo.reqForm) => {
  return RequestHttp.post<UserInfo.resData>(
    `${Config.safetyPath}/system/user/getUserInfoByToken`,
    params
  )
}
